<template>
  <!-- <card header-text="Users List"> -->
  <div class="card">
    <div class="card-header">
      <div class="row">
        <div class="col-md-10">
          <strong class="card-title mb-3">{{'Roles'}}</strong>
        </div>
        <div class="col-md-1">
          <!-- <download :tableId="'roles'" :fileName="'roles-list'"></download> -->
        </div>
        <div class="col-md-1">
          <goback></goback>
        </div>
      </div>
    </div>
    <div class="card-body">
      <div class="row mb5">
        <div class="col-md-3">
          <div class="form-group"></div>
        </div>
        <div class="col-md-7"></div>
        <div class="col-md-2"></div>
      </div>
      <div class="table-responsive app" v-dragscroll="true">
        <table
          id="roles"
          class="table table-sm first-td-padding table-bordered app-inner"
          v-if="rawData && rawData.length > 0"
        >
          <thead>
            <tr>
              <th>Sr.</th>
              <th v-for="field in tableFields" v-bind:key="'field'+field.title">{{field.title}}</th>
              <th v-if="actions.length>0">Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(row, ind) in rawData" v-bind:key="'row'+ind">
              <td>{{ind+1}}</td>
              <td
                v-for="field in tableFields"
                v-bind:key="field.name+ind"
              >{{row['_id'][field.name]}}</td>
              <td v-if="actions.length>0">
                <div class="action-btn-wrapper">
                  <span
                    v-for="(action, index) in actions"
                    v-bind:key="index+'-action-'+action.tooltip"
                  >
                    <a
                      style="margin:1px 4px"
                      class="btn btn-sm btn-small"
                      :class="action.btnClass"
                      @click.prevent="action.callback(row,ind,$event)"
                    >
                      <i :title="action.tooltip" class="fa" :class="action.icon"></i>
                    </a>
                  </span>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <!-- </card> -->
    </div>
  </div>
</template>
<script>
import http from "@/lib/http";
import { commonMixins } from "../../../assets/mixins/common.js";
import PinChange from "@/components/PinChange.vue";
import ChangePassword from "@/components/ChangePassword.vue";
export default {
  components: { PinChange, ChangePassword },
  mixins: [commonMixins],
  name: "Roles",
  created() {
    this.getRoles();
  },
  watch: {},
  data() {
    return {
      apiUrl: "roles",
      apiMode: true,
      company: {},
      actions: [
        {
          btnClass: "btn-primary",
          icon: "fa-edit cwhite",
          callback: this.editRole,
          tooltip: "Edit Role",
          type: "edit"
        }
      ],
      tableFields: [
        // {
        //   name: "role_id",
        //   title: "Role Id"
        // },
        {
          name: "role_name",
          title: "Role"
        }
      ],
      rawData: [],
      showChangePass: false,
      showChangePin: false,
      userId: 0
    };
  },
  methods: {
    reset() {
      this.getRoles();
    },
    getRoles() {
      let myself = this;
      http.get(this.apiUrl, {}, function(error, response) {
        console.log(response);
        myself.rawData = response;
      });
    },
    editRole(row, index, $event) {
      console.log(row, index, $event);
      this.$router.push({
        name: 'edit-roles',
        params: {id: index},
      });
    }
  }
};
</script>
<style>
.table td {
  padding: 5px 10px 5px 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/acl/roles/roles.vue